// extracted by mini-css-extract-plugin
export default {"imgWrapper":"AccountCreationSuccess_imgWrapper__OMzQm"};